import {useFormik} from 'formik'
import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {Button} from '../../../../_gori/partials/widgets'

type Props = {
  show: boolean
  disclaimerTitle: string
  disclaimerMessagePrimary: string
  disclaimerSubtitlePrimary: string
  disclaimerSubtitleSecondary?: string
  disclaimerTextPrimary: string
  disclaimerTextSecondary?: string
  disclaimerLearnMoreLink: string
  handlePrimaryAction: () => void
  handleSecondaryAction?: () => void
  loadingPrimary?: boolean
  loadingSecondary?: boolean
  handleClose: (status?: boolean) => void
  confirm?: (doNotShowAgain: boolean) => void
  showDoNotShowAgain?: boolean
}

const DisclaimerModal: React.FC<Props> = ({
  show = false,
  disclaimerTitle = '',
  disclaimerMessagePrimary = '',
  disclaimerSubtitlePrimary = '',
  disclaimerSubtitleSecondary = '',
  disclaimerTextPrimary = '',
  disclaimerTextSecondary = '',
  disclaimerLearnMoreLink = '',
  handleClose,
  confirm = () => {},
  showDoNotShowAgain = true,
}) => {
  const intl = useIntl()
  const [learnMoreClick, setlearnMoreClick] = useState<any>(false)
  const formik = useFormik({
    initialValues: {
      doNotShowAgain: false,
    },
    onSubmit: async (values) => {
      confirm(values.doNotShowAgain)
      handleCloseModal()
    },
  })

  const handleLearnMoreClick = (e) => {
    if (learnMoreClick) {
      setlearnMoreClick(false)
    } else {
      setlearnMoreClick(true)
    }
    e.preventDefault()
  }

  const handleCloseModal = () => {
    handleClose()
    formik.resetForm()
  }

  return (
    <Modal
      id='gori_modal_cheapest_service'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-lg h-auto'
      contentClassName='modal-padding'
      show={show}
      backdrop='static'
      onHide={() => {
        handleClose()
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'cheapest-disclaimer-title'}>{disclaimerTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mx-10 my-5 d-flex flex-column justify-content-center align-items-center fs-4'>
          <div className='mb-5'>
            <img src={toAbsoluteUrl('/media/gori/dashboard/error_balance.svg')} alt='img' />
          </div>
          <p className='disclaimer-text'>{disclaimerMessagePrimary}</p>
          <a href='/' className='disclaimer-link' onClick={handleLearnMoreClick}>
            {disclaimerLearnMoreLink}
            {learnMoreClick ? (
              <img
                src={toAbsoluteUrl('/media/gori/orders/minus.svg')}
                alt='img'
                width={16}
                height={17}
                style={{width: '16px', height: '17px'}}
              />
            ) : (
              <img
                src={toAbsoluteUrl('/media/gori/orders/plus.svg')}
                alt='img'
                width={16}
                height={17}
                style={{width: '16px', height: '17px'}}
              />
            )}
          </a>
          {learnMoreClick && (
            <div className='mb-4 mt-9'>
              <h5 className='disclaimer-sub-title'>{disclaimerSubtitlePrimary}</h5>
              <p className='disclaimer-text'>{disclaimerTextPrimary}</p>

              <h5 className='disclaimer-sub-title'>{disclaimerSubtitleSecondary}</h5>
              <p className='disclaimer-text'>{disclaimerTextSecondary}</p>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex w-100 align-items-center'>
          {showDoNotShowAgain && (
            <div className='form-check ms-2 me-auto'>
              <input
                className='form-check-input'
                type='checkbox'
                id='doNotShowAgain'
                checked={formik.values.doNotShowAgain}
                onChange={(e) => formik.setFieldValue('doNotShowAgain', e.target.checked)}
              />
              <label className='form-check-label' htmlFor='doNotShowAgain'>
                {intl.formatMessage({id: 'DO_NOT_SHOW_AGAIN'})}
              </label>
            </div>
          )}
          <div className='d-flex justify-content-end'>
            <Button
              className='btn btn-advanced-secondary me-2'
              label={intl.formatMessage({id: 'CANCEL'})}
              loadingText={intl.formatMessage({id: 'CANCEL'})}
              event={handleCloseModal}
            />
            <Button
              className='btn btn-advanced-primary'
              label={intl.formatMessage({id: 'CONFIRM'})}
              loadingText={intl.formatMessage({id: 'CONFIRM'})}
              event={formik.submitForm}
            />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export {DisclaimerModal}
